const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaCidade: [],
	listaEstado: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'CLIENTE_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'CLIENTE_LISTADO':
			return { ...state, lista: action.payload.data };

		case 'CLIENTE_CIDADE_LISTADO':
			return { ...state, listaCidade: action.payload.data };
		
		case 'CLIENTE_ESTADO_LISTADO':
			return { ...state, listaEstado: action.payload.data };

		case 'CLIENTE_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		default:
			return state;
	}
}
